/*
  SME parts navigation: My truck, live part counts, truck-scoped links,
  "Fits your truck" badges, the home truck finder and NSN search.
  Taxonomy comes from sme-taxonomy.js (window.SME_TAX); counts come from the
  sme-facet-counts section rendered on /collections/all.
*/
(() => {
  const KEY = 'sme-mytruck';
  const P = {
    truck: 'filter.p.m.sme.fits_truck',
    model: 'filter.p.m.sme.fits_model',
    system: 'filter.p.m.sme.system',
    subsystem: 'filter.p.m.sme.subsystem',
    vendor: 'filter.p.vendor',
  };
  const TAX = window.SME_TAX || { trucks: [] };
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ALL = `${ROOT}collections/all`;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const fmt = (n) => Number(n).toLocaleString('en-US');
  const truckInfo = (value) => TAX.trucks.find((t) => t.value === value);

  // ---------------------------------------------------------------- my truck
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  };
  let garage = read();
  const label = (g) => (g ? g.model || g.truck : '');

  function save(g) {
    garage = g;
    try {
      if (g) localStorage.setItem(KEY, JSON.stringify(g));
      else localStorage.removeItem(KEY);
    } catch (e) {}
    paintAll();
  }

  // ---------------------------------------------------------------- counts
  const cache = new Map();
  function scopeQuery(scope) {
    const q = new URLSearchParams();
    if (scope && scope.truck) q.append(P.truck, scope.truck);
    if (scope && scope.model) q.append(P.model, scope.model);
    return q.toString();
  }
  function counts(scope) {
    const q = scopeQuery(scope);
    const url = `${ALL}?section_id=sme-facet-counts${q ? `&${q}` : ''}`;
    if (!cache.has(url)) {
      cache.set(
        url,
        fetch(url, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((t) => {
            const el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-sme-counts]');
            return el ? JSON.parse(el.textContent) : null;
          })
          .catch(() => null)
      );
    }
    return cache.get(url);
  }
  function fillCounts(container, data) {
    if (!data) return;
    container.querySelectorAll('[data-sme-count]').forEach((el) => {
      const values = data.filters[P[el.dataset.smeCount]];
      if (!values) return;
      const n = values[el.dataset.value] || 0;
      const style = el.dataset.style || 'parts';
      el.textContent = style === 'paren' ? `(${fmt(n)})` : style === 'num' ? fmt(n) : `${fmt(n)} part${n === 1 ? '' : 's'}`;
      const item = el.closest('[data-sme-item]');
      if (item && container.contains(item)) item.hidden = n === 0;
    });
  }
  // fill every [data-sme-count] inside a container, grouped by the truck scope set on it
  function hydrate(container) {
    if (container.dataset.smeHydrated) return;
    container.dataset.smeHydrated = '1';
    const groups = container.querySelectorAll('[data-sme-counts-scope]');
    (groups.length ? [...groups] : [container]).forEach((g) => {
      const scope = g.dataset.truck ? { truck: g.dataset.truck } : null;
      counts(scope).then((d) => fillCounts(g, d));
    });
  }

  // ---------------------------------------------------------------- scoped links
  function scopeHref(href, scope) {
    const u = new URL(href, window.location.origin);
    u.searchParams.delete(P.truck);
    u.searchParams.delete(P.model);
    u.searchParams.delete('page');
    if (scope && scope.truck) u.searchParams.append(P.truck, scope.truck);
    if (scope && scope.model) u.searchParams.append(P.model, scope.model);
    return u.pathname + u.search;
  }
  // links marked data-sme-scope follow My truck; data-sme-truck-link links follow it only for that truck
  function scopeLinks(container, scope, skipHome) {
    container.querySelectorAll('a[data-sme-scope]').forEach((a) => {
      if (skipHome && a.closest('[data-sme-tiles], [data-sme-finder]')) return;
      if (!a.dataset.smeBase) a.dataset.smeBase = a.getAttribute('href');
      a.setAttribute('href', scopeHref(a.dataset.smeBase, scope));
    });
  }
  function scopeTruckLinks(container) {
    container.querySelectorAll('a[data-sme-truck-link]').forEach((a) => {
      if (!a.dataset.smeBase) a.dataset.smeBase = a.getAttribute('href');
      const t = a.dataset.smeTruckLink;
      a.setAttribute('href', scopeHref(a.dataset.smeBase, garage && garage.truck === t ? garage : { truck: t }));
    });
  }

  // ---------------------------------------------------------------- paint
  function inGarageView() {
    if (!garage) return false;
    const q = new URLSearchParams(window.location.search);
    const t = q.getAll(P.truck);
    const m = q.getAll(P.model);
    return t.length === 1 && t[0] === garage.truck && (!garage.model || (m.length === 1 && m[0] === garage.model));
  }
  function paintBadges(container = document) {
    const quiet = inGarageView();
    container.querySelectorAll('[data-sme-fit]').forEach((b) => {
      const trucks = (b.dataset.trucks || '').split('|');
      const models = (b.dataset.models || '').split('|');
      const fits = !!garage && trucks.includes(garage.truck) && (!garage.model || models.includes(garage.model));
      b.hidden = !fits || (quiet && !b.hasAttribute('data-always'));
      if (fits && b.hasAttribute('data-long')) b.textContent = `Fits your ${label(garage)}`;
    });
  }
  function paintHeader() {
    document.querySelectorAll('[data-sme-mytruck-label]').forEach((el) => {
      el.textContent = garage ? label(garage) : el.dataset.empty;
    });
    document.querySelectorAll('[data-sme-mytruck]').forEach((el) => el.classList.toggle('is-set', !!garage));
  }
  function paintMyFilter() {
    document.querySelectorAll('[data-sme-myfilter]').forEach((el) => {
      el.hidden = !garage || inGarageView();
      if (el.hidden) return;
      const a = el.querySelector('a');
      a.href = scopeHref(window.location.pathname + window.location.search, garage);
      a.querySelector('[data-sme-mytruck-name]').textContent = label(garage);
    });
  }
  function paintAll() {
    paintHeader();
    paintBadges();
    paintMyFilter();
    // menus (desktop and drawer) and quick links follow My truck; the home tiles follow the finder
    scopeLinks(document, garage, true);
    scopeTruckLinks(document);
    if (!finderPick) document.dispatchEvent(new CustomEvent('sme:scope', { detail: garage }));
  }

  // ---------------------------------------------------------------- garage dialog
  function fillModelSelect(dlg, truck, selected) {
    const sel = dlg.querySelector('[name="model"]');
    const t = truckInfo(truck);
    const models = (t && t.models) || [];
    sel.innerHTML =
      `<option value="">All ${esc(t ? t.short : truck)} models</option>` +
      models.map((m) => `<option value="${esc(m)}"${m === selected ? ' selected' : ''}>${esc(m)}</option>`).join('');
    sel.disabled = !models.length;
  }
  function openGarage() {
    const dlg = document.getElementById('SmeGarage');
    if (!dlg || !TAX.trucks.length) return;
    const ts = dlg.querySelector('[name="truck"]');
    ts.innerHTML = TAX.trucks.map((t) => `<option value="${esc(t.value)}">${esc(t.name)}</option>`).join('');
    ts.value = garage ? garage.truck : TAX.trucks[0].value;
    fillModelSelect(dlg, ts.value, garage && garage.model);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  }
  function initGarage() {
    const dlg = document.getElementById('SmeGarage');
    if (!dlg) return;
    dlg.querySelector('[name="truck"]').addEventListener('change', (e) => fillModelSelect(dlg, e.target.value, null));
    dlg.querySelector('[data-sme-garage-form]').addEventListener('submit', (e) => {
      e.preventDefault();
      const truck = dlg.querySelector('[name="truck"]').value;
      const model = dlg.querySelector('[name="model"]').value || null;
      save({ truck, model });
      dlg.close();
    });
    dlg.querySelector('[data-sme-forget]').addEventListener('click', () => {
      save(null);
      dlg.close();
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  }

  // ---------------------------------------------------------------- home: truck finder + tiles
  let finderPick = null;
  let rememberPick = true;

  function initFinder(sec) {
    const trucks = sec.querySelectorAll('[data-sme-truck]');
    const modelsBox = sec.querySelector('[data-sme-models]');
    const list = sec.querySelector('[data-sme-model-list]');
    const go = sec.querySelector('[data-sme-go]');
    const goLink = sec.querySelector('[data-sme-go-link]');
    const remember = sec.querySelector('[data-sme-remember]');
    counts(null).then((d) => fillCounts(sec.querySelector('[data-sme-trucks]'), d));

    function setPick(p) {
      finderPick = p;
      trucks.forEach((b) => b.setAttribute('aria-pressed', String(!!p && b.dataset.smeTruck === p.truck)));
      document.dispatchEvent(new CustomEvent('sme:scope', { detail: p || garage }));
      if (!p) {
        modelsBox.hidden = true;
        go.hidden = true;
        return;
      }
      const t = truckInfo(p.truck);
      const models = (t && t.models) || [];
      modelsBox.hidden = models.length < 2;
      list.innerHTML = [
        `<button type="button" class="sme-model" data-model="" aria-pressed="${!p.model}">All ${esc(t ? t.short : p.truck)} <span data-sme-count="truck" data-value="${esc(p.truck)}" data-style="num"></span></button>`,
      ]
        .concat(
          models.map(
            (m) =>
              `<button type="button" class="sme-model" data-model="${esc(m)}" aria-pressed="${p.model === m}" data-sme-item>${esc(m)} <span data-sme-count="model" data-value="${esc(m)}" data-style="num"></span></button>`
          )
        )
        .join('');
      counts({ truck: p.truck }).then((d) => fillCounts(list, d));
      goLink.href = scopeHref(ALL, p);
      goLink.textContent = `Shop ${label(p)} parts`;
      counts(p).then((d) => {
        if (d && finderPick === p) goLink.textContent = `Shop ${fmt(d.total)} ${label(p)} parts`;
      });
      go.hidden = false;
    }

    trucks.forEach((b) =>
      b.addEventListener('click', () => setPick(finderPick && finderPick.truck === b.dataset.smeTruck && !finderPick.model ? null : { truck: b.dataset.smeTruck, model: null }))
    );
    list.addEventListener('click', (e) => {
      const b = e.target.closest('[data-model]');
      if (b) setPick({ truck: finderPick.truck, model: b.dataset.model || null });
    });
    remember.addEventListener('change', () => (rememberPick = remember.checked));
    if (garage) setPick({ truck: garage.truck, model: garage.model });
  }

  function initTiles(sec) {
    const title = sec.querySelector('[data-sme-tiles-title]');
    const note = sec.querySelector('[data-sme-tiles-note]');
    function apply(scope) {
      scopeLinks(sec, scope);
      title.textContent = scope ? `${label(scope)} parts by system` : title.dataset.default;
      note.textContent = scope ? 'Counts and links are for this truck.' : note.dataset.default;
      counts(scope).then((d) => {
        if (!d) return;
        fillCounts(sec, d);
        sec.querySelectorAll('[data-sme-subs]').forEach((ul) => {
          const items = [...ul.querySelectorAll(':scope > li[data-sme-item]')].filter((li) => !li.hidden);
          items.sort((a, b) => num(b) - num(a)).forEach((li) => ul.appendChild(li));
          items.forEach((li, i) => li.classList.toggle('sme-overflow', i >= 5));
          let more = ul.querySelector('.sme-sys__all');
          if (items.length > 5) {
            if (!more) {
              more = document.createElement('li');
              more.className = 'sme-sys__all';
              more.innerHTML = `<a data-sme-scope href="${esc(ul.dataset.allLink)}"></a>`;
              ul.appendChild(more);
            }
            const a = more.querySelector('a');
            a.dataset.smeBase = ul.dataset.allLink;
            a.setAttribute('href', scopeHref(ul.dataset.allLink, scope));
            a.textContent = `All ${items.length} sections`;
            more.hidden = false;
          } else if (more) more.hidden = true;
        });
      });
    }
    const num = (li) => Number((li.querySelector('[data-sme-count]').textContent || '0').replace(/[^\d]/g, ''));
    document.addEventListener('sme:scope', (e) => apply(e.detail));
    apply(finderPick || garage);
  }

  // remember the finder's truck when the shopper follows one of its links
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-sme-scope], a[data-sme-go-link]');
    if (a && finderPick && rememberPick && a.closest('[data-sme-finder], [data-sme-tiles]')) save({ ...finderPick });
    if (e.target.closest('[data-sme-open-garage]')) openGarage();
    const copy = e.target.closest('[data-sme-copy]');
    if (copy) {
      const done = () => {
        copy.textContent = 'Copied';
        setTimeout(() => (copy.textContent = 'Copy'), 1400);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.smeCopy).then(done, () => {});
    }
  });

  // ---------------------------------------------------------------- NSN search
  // 2930014446649 -> 2930-01-444-6649, the form the titles and tags use
  document.addEventListener(
    'submit',
    (e) => {
      const q = e.target instanceof HTMLFormElement && e.target.querySelector('input[name="q"]');
      if (!q) return;
      const v = q.value.trim();
      if (/^\d{13}$/.test(v)) q.value = `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 9)}-${v.slice(9)}`;
    },
    true
  );

  // ---------------------------------------------------------------- collection header refresh
  // the theme's filters swap the product grid without a page load; redraw our header with it
  function refreshCollectionHeader() {
    const h = document.querySelector('[data-sme-collection-header]');
    if (!h) return;
    const u = new URL(window.location.href);
    u.searchParams.set('section_id', h.dataset.sectionId);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((t) => {
        const n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-sme-collection-header]');
        if (n) {
          h.replaceWith(n);
          paintMyFilter();
        }
      })
      .catch(() => {});
  }
  const push = window.history.pushState;
  window.history.pushState = function (...args) {
    const r = push.apply(this, args);
    setTimeout(() => {
      refreshCollectionHeader();
      paintBadges();
    }, 0);
    return r;
  };
  window.addEventListener('popstate', () => setTimeout(refreshCollectionHeader, 0));

  // product grids re-render after filtering; paint new badges as they arrive
  let pending = 0;
  new MutationObserver((muts) => {
    if (pending) return;
    if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-sme-fit]') || n.querySelector('[data-sme-fit]'))))) {
      pending = requestAnimationFrame(() => {
        pending = 0;
        paintBadges();
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---------------------------------------------------------------- start
  function start() {
    initGarage();
    document.querySelectorAll('[data-sme-menu] details').forEach((d) =>
      d.addEventListener('toggle', () => {
        if (d.open) hydrate(d);
      })
    );
    document.querySelectorAll('[data-sme-finder]').forEach(initFinder);
    document.querySelectorAll('[data-sme-tiles]').forEach(initTiles);
    // partners page: "Shop their parts here (n)", hidden for partners with no parts listed
    document.querySelectorAll('[data-sme-partners]').forEach(hydrate);
    paintAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
